import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'
import { OptionDropdown } from '@/components/view/OptionDropdown'
import { OptionDropdownItem } from '@/components/view/OptionDropdownItem'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { useState } from 'react'
import { formatConditionSourcingRouteDisplay } from '../../utils'
import { SourcingRoute } from '../../reducers/sourcingAnnotationCandidates'
import { Cover } from '../../../../common/Cover'
import { SourcingRouteId } from '../../reducers/condition'

type Props = {
  sourcingRoutes: SourcingRoute[]
  sourcingRouteIds: SourcingRouteId[]
  onResetOffset: () => void
  onSelectSourcingRoute: (payload: { id: number }) => void
}

export const SourcingRouteCondition: React.FC<Props> = ({
  sourcingRoutes,
  sourcingRouteIds,
  onResetOffset,
  onSelectSourcingRoute,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelectSourcingRoute = (id: number) => {
    onResetOffset()
    onSelectSourcingRoute({ id })
  }

  return (
    <div>
      <button
        className="condition-label"
        css={css`
          display: flex;
          max-width: 300px;
          align-items: center;
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          font-size: 13px;
          position: relative;
          margin-right: 5px;
          border: none;
          cursor: pointer;
          outline: none;
          padding: 5px 10px 5px 15px;
        `}
        onClick={() => {
          setIsOpen((prev) => !prev)
        }}
      >
        <span
          css={css`
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          `}
        >
          ソーシングルート
          {formatConditionSourcingRouteDisplay(
            sourcingRoutes,
            sourcingRouteIds
          )}
        </span>
        <IcomoonIcon
          name="arrow8-down"
          css={css`
            font-size: 10px;
            color: ${colors.white10};
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      </button>
      {isOpen && <Cover handleClick={() => setIsOpen((prev) => !prev)} />}
      <OptionDropdown
        open={isOpen}
        _css={css`
          max-height: 265px;
          overflow-y: auto;
        `}
      >
        {sourcingRoutes.map((sr, idx) => (
          <OptionDropdownItem
            key={idx}
            condition={sourcingRouteIds
              .map((selected) => selected.id)
              .includes(sr.id)}
            idx={idx}
            handleSet={() => {
              handleSelectSourcingRoute(sr.id)
            }}
            label={sr.name}
            _css={css`
              max-width: 300px;
              text-overflow: ellipsis;
            `}
          />
        ))}
      </OptionDropdown>
    </div>
  )
}
